export const SITE_ORIGIN = "https://femcare.life";

const PAGE_META = {
    "/": ["Femcare.life — Your private women's health companion", "Femcare.life — Your private women's health companion. Cycle tracking, fertility predictions, pregnancy support, and AI-powered insights."],
    "/features": ["Features — Cycle, Pregnancy, AI Coach & more · Femcare.life", "Explore every Femcare feature: period and cycle tracking, fertility window, pregnancy week-by-week, AI Health Coach, Daughter Care, Community and Insights."],
    "/features/cycle": ["Period & Cycle Tracker · Femcare.life", "Track your period, symptoms and moods, and get accurate cycle, ovulation and fertile-window predictions with Femcare."],
    "/features/pregnancy": ["Pregnancy Tracker Week by Week · Femcare.life", "Follow your pregnancy week by week with baby growth updates, symptom logs and gentle guidance from Femcare."],
    "/features/ai-coach": ["AI Health Coach · Femcare.life", "Ask Femcare's AI Health Coach private questions about your cycle, symptoms and wellbeing and get personalised, easy-to-understand answers."],
    "/features/daughter-care": ["Daughter Care — Track Your Daughter's First Periods · Femcare.life", "Help your daughter through her first periods with Femcare Daughter Care: gentle tracking, reminders and age-appropriate guidance for parents."],
    "/features/community": ["Women's Health Community · Femcare.life", "Join a safe, moderated community of women sharing experiences about periods, fertility, pregnancy and wellbeing on Femcare."],
    "/features/insights": ["Health Insights & Trends · Femcare.life", "See trends across your cycles, symptoms, sleep and mood with Femcare Insights and understand your body better over time."],
    "/fitness": ["FemCare Fitness — Yoga, Dance & Strength Workouts for Women · Femcare.life", "Women-only workouts that match your cycle: yoga, Zumba-style dance cardio, strength, Pilates and walking plans with a timer and voice guidance, plus gyms and studios near you."],
  "/about": ["About Us — Our Mission · Femcare.life", "Learn about Femcare.life, the team and mission behind a private, science-backed women's health companion."],
    "/services": ["Services · Femcare.life", "Discover the services Femcare offers for menstrual health, fertility awareness, pregnancy and family care."],
    "/community": ["Community — Stories & Support · Femcare.life", "Read and share real stories, questions and support with the Femcare women's health community."],
    "/pricing": ["Pricing & Premium Plans · Femcare.life", "Compare Femcare Free and Premium plans, including AI Health Coach, Daughter Care and advanced insights. Simple, transparent pricing."],
    "/contact": ["Contact Us · Femcare.life", "Get in touch with the Femcare.life team for questions, partnerships or press enquiries."],
    "/blog": ["Journal — Women's Health Articles · Femcare.life", "Expert-reviewed articles on periods, fertility, pregnancy, hormones and everyday wellbeing from the Femcare Journal."],
    "/privacy": ["Privacy Policy · Femcare.life", "Read how Femcare.life collects, uses and protects your personal and health data."],
    "/terms": ["Terms of Service · Femcare.life", "The terms that govern your use of the Femcare.life website, mobile app, subscriptions and community."],
    "/support": ["Help & Support · Femcare.life", "Find answers to common questions about your Femcare account, subscription, data and app features, or contact support."],
    "/download": ["Download the App for Android & iOS · Femcare.life", "Download Femcare.life free on Google Play and the App Store and start tracking your cycle in minutes."],
    "/affiliate": ["Affiliate Program · Femcare.life", "Partner with Femcare.life and earn commission by recommending a trusted women's health app."],
    "/delete-account": ["Delete Your Account · Femcare.life", "Request permanent deletion of your Femcare.life account and associated data."],
};

function upsert(selector, create, attr, value) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
}

export function setPageMeta({ title, description, path }) {
    const url = SITE_ORIGIN + (path === "/" ? "/" : path);
    document.title = title;
    const meta = (key, name) => upsert(`meta[${key}="${name}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute(key, name);
        return m;
    }, "content", name.includes("title") ? title : description);
    meta("name", "description");
    meta("property", "og:title");
    meta("property", "og:description");
    meta("name", "twitter:title");
    meta("name", "twitter:description");
    upsert('meta[property="og:url"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:url");
        return m;
    }, "content", url);
    upsert('link[rel="canonical"]', () => {
        const l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        return l;
    }, "href", url);
}

export function applyRouteMeta(pathname) {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
    const entry = PAGE_META[path];
    if (entry) setPageMeta({ title: entry[0], description: entry[1], path });
}
